import * as React from 'react';

function ProficiencyLevels(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={345} height={24} viewBox="0 0 345 24" {...props}>
      <g fill="none" fillRule="evenodd">
        <path fill="var(--cds-color-grey-800)" d="M106.667 5h118v14h-118z" />
        <path d="M228 5h80a7 7 0 010 14h-80V5z" fill="var(--cds-color-neutral-primary)" />
        <path fill="var(--cds-color-grey-400)" d="M44.334 5h59v14h-59z" />
        <path d="M18 5h23v14H18a7 7 0 010-14z" fill="var(--cds-color-grey-200)" />
        <text fontSize={14} fontWeight="bold" fill="var(--cds-color-grey-400)">
          <tspan x={0} y={15}>
            0
          </tspan>
        </text>
        <text fontSize={14} fontWeight="bold" fill="var(--cds-color-grey-400)">
          <tspan x={321} y={15}>
            500
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default ProficiencyLevels;
